export function getTemplateFormGridColumnSpan(size: number) {
  if (size % 5 !== 0) {
    throw new Error('Size must be a multiple of 5.');
  }

  return `grid-column-span-${size / 5}`;
}
